<!--
@component
GroupsPage

See markup below.
-->

<script lang="ts">
  import GroupTable from '$lib/components/GroupTable/index.svelte';
  import ViewSwitch from '$lib/components/common/ViewSwitch/index.svelte';
  import { appState } from '$lib/stores/index.svelte';

  type Props = {
    /** Opta `matches` payload (typed loosely to mirror `appState.optaData`). */
    data: Record<string, any>;
  };

  let { data }: Props = $props();
</script>

<!-- {#if appState.showKnockouts}
  <ViewSwitch to="knockouts" label="Switch to Knockouts" />
{/if} -->
<h1 class="visually-hidden">Group standings and Results</h1>
<GroupTable {data} routed />
